import { Input } from '@/components/ui/input'
import { FormField } from '@/components/ui/form-field'
import { CountrySelect } from '@/components/country-select'

export type EntityLocationValue = {
  city: string
  country: string
}

type EntityLocationFieldsProps = {
  value: EntityLocationValue
  onChange: (patch: Partial<EntityLocationValue>) => void
  idPrefix?: string
  disabled?: boolean
}

/** City + country grid for identity editors (person, organisation, onboarding). */
export function EntityLocationFields({
  value,
  onChange,
  idPrefix = 'entity-location',
  disabled = false,
}: EntityLocationFieldsProps) {
  const cityId = `${idPrefix}-city`
  const countryId = `${idPrefix}-country`

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <FormField label="City" htmlFor={cityId}>
        <Input
          id={cityId}
          value={value.city}
          onChange={(event) => onChange({ city: event.target.value })}
          placeholder="Enter city"
          disabled={disabled}
        />
      </FormField>
      <FormField label="Country" htmlFor={countryId}>
        <CountrySelect
          id={countryId}
          value={value.country}
          onValueChange={(code) => onChange({ country: code })}
          disabled={disabled}
        />
      </FormField>
    </div>
  )
}
